import { Pipe, PipeTransform } from '@angular/core';

/**
 * Empty values will be transformed into an 'N/A' string.
 */
@Pipe({
    name: 'emptyNA',
    standalone: true
})
export class EmptyNAPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value){
      return 'N/A';
    }

    return value;
  }

}
